import type { UserSessionData } from 'noddi-web';
import { useUserGroupDialogActions } from '../stores/userGroupDialogStore';
import { getSelectableUserGroups } from '../utils/userGroupContext';

export const useOnImpersonated = () => {
  const { openUserGroupDialog } = useUserGroupDialogActions();

  return (userData: UserSessionData) => {
    if (getSelectableUserGroups(userData).length > 1) {
      openUserGroupDialog();
    }
  };
};
